
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import JsBarcode from "jsbarcode";
import "./print.scss";
import { getSingleDataEntry, getSingleDataEntrySuccess } from "../../../modules/actions/dataEntryActions";
import { deleteGeneratedEntry } from "../../../modules/actions/reportsAction";
import logo from "./../../../Images/Logo 2.png";

function TakeInPrint(props) {
	const [printObj, setPrintObj] = useState({});
	const [entryNumber, setEntryNumber] = useState("");

	useEffect(() => {
		JsBarcode("#barcode", printObj.entryNo, {
			format: "CODE128",
			// lineColor: "#0aa",
			width: 1,
			height: 50,
			displayValue: false
		});
	}, [printObj]);
	function printElem() {
		var sTable = document.getElementById("main").innerHTML;
		var win = window.open();

		var style = `<style>
        
        body{
            -webkit-print-color-adjust:exact;
            margin:0px;
            zoom:80%; 
        }
        .innerRecieptPage{
            margin-top: 94px;
        }
        @media print{
               
            .innerRecieptPage{
            margin-top: 30px;
          }
          .innerRecieptPage{
            
              footer {page-break-after: always;}
              
            }
            .innerRecieptPage:not(:first-child){
                margin-top: 160px;
                
            }
          }

          .table1 .bold, .table2 .bold{
              text-align:left
          }
     
          .takeInPrint {
            padding: 24px;
    height: calc(100vh - 55px);
       }
        .takeInPrint .innerRecieptPage {
            width: 100%;
            zoom: 100% !important;
            display: flex;
            align-items: center;
            justify-content: space-between;
       }
        .takeInPrint .innerRecieptPage .printRecipt {
            width: 47%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
       }
       .takeInPrint .innerRecieptPage .printRecipt .itemListRecipt{
        height: 326.91px;
       }
        .takeInPrint .innerRecieptPage .printRecipt .headReciept {
            font-size: 16px;
            text-align: center;
       }
        .takeInPrint .innerRecieptPage .printRecipt .recieptDetail {
            display: flex;
       }
        .takeInPrint .innerRecieptPage .printRecipt .recieptDetail .table1 {
            width: 60%;
       }
        .takeInPrint .innerRecieptPage .printRecipt .recieptDetail .table2 {
            width: 40%;
       }
       .takeInPrint .innerRecieptPage .printRecipt .recieptDetail .table2 th{
           text-align:left;
           padding: 2px 0px;
       }
       .takeInPrint .innerRecieptPage .printRecipt .recieptDetail .customerDet tr{
           height: 16px;
        }
        .takeInPrint .innerRecieptPage .printRecipt .recieptDetail .customerDet th {
            font-size: 11.4px;
            font-weight: bold;
            text-align:left;
            line-height: 16px;
       }
        .takeInPrint .innerRecieptPage .printRecipt .recieptDetail .customerDet td {
            font-size: 14.4px;
       }
        .takeInPrint .innerRecieptPage .printRecipt .recieptDetail .table2 {
            font-size: 14.4px;
       }
        .takeInPrint .innerRecieptPage .printRecipt .recieptDetail .table2 td {
            text-align: right;
       }
        .takeInPrint .innerRecieptPage .itemListRecipt table {
            border-collapse: collapse;
            border: 1px solid black;
            width: 100%;
            font-size: 0.84em;
       }
        .takeInPrint .innerRecieptPage .itemListRecipt table th {
            border: 1px solid black;
            background: #b2b2b2;
            font-size: 13.44px;
            text-align: center;
       }
        .takeInPrint .innerRecieptPage .itemListRecipt table td {
            text-align: center;
            font-size: 13.44px;
            border-bottom: 1px solid black;
       }
        .takeInPrint .innerRecieptPage .itemListRecipt table .td1 {
            font-size: 0.9em;
            font-style: italic;
            text-align: left;
       }
        .takeInPrint .innerRecieptPage .recipetTotalTable {
            width: 45%;
            float: right;
            font-size: 12.8px;
            margin-top: 15px;
       }
       .takeInPrint .innerRecieptPage .recipetTotalTable tr{
           text-align: left;
       }
        .takeInPrint .innerRecieptPage .recipetTotalTable tr th + th {
            text-align: right;
       }
        .takeInPrint .recipetTotal {
            display: flex;
            justify-content: space-between;
            align-items: center;
       }
        .takeInPrint .recipetTotal .signCust {
            margin-top: 0px;
            padding: 0px 15px;
       }
        .takeInPrint .recipetTotal .signCust p {
            font-size: 11px;
            text-align: center;
            font-weight: 700;
       }
        .takeInPrint .recipetTotal .signCust .signBox {
            text-align: center;
            font-weight: 600;
            margin-top: 30px;
       }
        .printReciptBtn {
            background: #d40000;
            color: white;
            border: none;
            padding: 5px 20px;
            font-weight: bold;
            border-radius: 25px;
            margin: 0px 10px;
       }
        .backReciptBtn {
            background: #41a4ff;
            color: white;
            border: none;
            padding: 5px 20px;
            font-weight: bold;
            border-radius: 25px;
            margin: 0px 10px;
            margin-right: 5px;
       }
        

       </style>
        `;
		var style2 = `<style>
        * {
        margin: 0;
        padding: 0;
    }
        #main{
            margin: 0;
            padding: 0;
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 7%;
        }
        #mainDiv {
            width: 45%;
            height: 100%;
            margin-left: 20px;
        }
        #heading {
            width: 100%;
            text-align: center;
        }
        #headDiv {
            width: 100%;
            display: inline-block;
            font-size: 0.9em;
        }
        #table1 {
            margin-top: 10px;
            float: left;
            width: 60%;
        }
        #table1 .bold {
            font-size: 0.8em;
        }
        .text1 {
            padding-left: 5px;
        }
        .color {
            background: rgba(0, 0, 0, 0.3);
            -webkit-print-color-adjust: exact;
        }
        #table2 {
            margin-top: 10px;
            float: right;
            width: 40%;
        }
        .bold {
            font-weight: bold;
        }
        .text {
            text-align: right;
        }
        #center {
            text-align: right;
        }
        #div2 {
            width: 100%;
            height: 55vh;
        }
        #mainTable {
            border: 2px solid black;
            width: 100%;
            font-size: 0.84em;
            border-collapse: collapse;
        }
        .color {
            background: rgba(0, 0, 0, 0.3);
            -webkit-print-color-adjust: exact;
        }
        .tr {
            border-right: 1px solid black;
        }
        #mainTable td {
            border-top: 1px solid black;
        }
        #mainTable td {
            border-top: 1px solid black;
        }
        #td1 {
            font-size: 0.9em;
            font-style: italic;
        }
        #td2 {
            text-align: center;
        }
        #div3 {
            width: 100%;
            display: flex;
            margin-top: 10px;
        }
        #divP {
            width: 50%;
            flex: 1;
            /* float: left; */
            font-size: 0.7em;
            font-style: italic;
        }
        p {
            text-align: center;
        }
        #tableDiv {
            width: 50%;
            flex: 1;
            /* text-align: right; */
            /* float: right; */
        }
        #bottomTable {
            width: 78%;
            float: right;
            font-size: 0.8em;
        }
        #bottomTable {
            border-collapse: collapse;
        }
        .color {
            background: rgba(0, 0, 0, 0.3);
            -webkit-print-color-adjust: exact;
        }
        .textI {
            font-style: italic;
            text-align: center;
        }
        #bottomTable #border {
            border-top: 1px solid black;
        }
        .padding {
            padding-top: 5px;
        }
        #sign {
            margin-top: 20px;
            font-size: 0.9em;
            width: 50%;
            text-align: center;
        }
        #mainDiv2 {
            width: 47%;
            height: 100%;
            margin-right: 20px;
        }
        #heading {
            width: 100%;
            text-align: center;
        }
        #headDiv {
            width: 100%;
            display: inline-block;
            font-size: 0.9em;
        }
        #table1 {
            margin-top: 10px;
            float: left;
            width: 60%;
        }
        #table2 {
            margin-top: 10px;
            float: right;
            width: 40%;
        }
        #mainTable1 {
            border-collapse: collapse;
        }
        #mainTable1 {
            border: 2px solid black;
            font-size: 0.84em;
            width: 100%;
        }
        .tr {
            border-right: 1px solid black;
        }
        #mainTable1 td {
             border-top: 1px solid black;
        }
        #td1 {
            font-size: 0.9em;
            font-style: italic;
        }
        #td2 {
            text-align: center;
        }
        #td {
            text-align: center;
        }
        </style>`;

		win.document.write("<html><head>");
		win.document.write("<title>Profile</title>");
		// win.document.write('<link href="./././print.css" rel="stylesheet">')
		win.document.write(style);
		win.document.write('<script src="JsBarcode.all.min.js"></script>');

		win.document.write("</head>");
		win.document.write("<body>");


		win.document.write('<div id="main" class="reciptPage takeInPrint">');
		win.document.write(sTable);
		//                     <tbody><tr>
		//                     <td id="td">1</td>
		//                     <td id="td1">Gemstone Jewellery Card<br>&nbsp;</td>
		//                     <td id="td">White</td>
		//                     <td id="td">1</td>
		//                     <td id="td">1g</td>
		//                     <td id="td">0</td>
		//                     <td id="td">0</td>
		//                     <td id="td2" class="bold">0/-</td>
		//             </tr>
		//                     </tbody>
		//                 <tbody><tr>
		//         <td id="td">1/a</td>
		//                 <td id="td1">Gemstone Jewellery Card<br>&nbsp;</td>
		//                 <td id="td">red</td>
		//                 <td id="td">2</td>
		//                 <td id="td">1</td>
		//                 <td id="td">0</td>
		//                 <td id="td">0</td>
		//                 <td id="td2" class="bold">1000/-</td>
		//                 </tr>
		//                 </tbody></table></div><div id="div3"><div id="divP"><p>I agree to the terms and conditions written on the back of the receipt.</p><p>میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.</p></div><div id="tableDiv"><table id="bottomTable" class="bold"><tbody><tr><th>Total Amount: </th><td class="color textI">1000</td></tr><tr><th>Advance: </th><td class=" textI">0</td></tr><tr id="border"><th class="padding">Balance: </th><td class="color  textI padding">1000</td></tr></tbody></table></div></div><div id="sign" class="h3"><h3>Customer Sign</h3></div></div><div id="mainDiv2"><div id="heading">Customer Copy</div><div id="headDiv"><table id="table1"><tbody><tr><td class="bold">Customer Name: </td><td class="text1">Sadiq</td></tr><tr><td class="bold">Customer Id: </td><td class="text1">ISL-Cu-1</td></tr><tr><td class="bold">Recipt no: </td><td class="text1">20210601105331523</td></tr><tr><td class="bold">Mobile No: </td><td class="text1">6653235623</td></tr><tr class="color"><td class="bold">Delivery Date: </td><td class="text1">2-6-2021</td></tr><tr><td class="bold">Entered By: </td><td class="text1">sadiq hanif</td></tr></tbody></table><table id="table2"><tbody><tr><td class="bold">Print Date: </td><td class="text">1-6-2021</td></tr><tr><td class="bold">Print Time: </td><td class="text">10:53:31 AM</td></tr><tr class="color"><td class="bold">Box No:  </td><td class="text">1</td></tr><tr><td colspan="2" id="center"><svg id="code128" width="165px" height="65px" x="0px" y="0px" viewBox="0 0 165 65" xmlns="http://www.w3.org/2000/svg" version="1.1" style="transform: translate(0,0)"><rect x="0" y="0" width="165" height="65" style="fill:#ffffff;"></rect><g transform="translate(10, 10)" style="fill:#000000;"><rect x="0" y="0" width="2" height="45"></rect><rect x="3" y="0" width="1" height="45"></rect><rect x="6" y="0" width="3" height="45"></rect><rect x="11" y="0" width="2" height="45"></rect><rect x="15" y="0" width="1" height="45"></rect><rect x="18" y="0" width="3" height="45"></rect><rect x="22" y="0" width="2" height="45"></rect><rect x="25" y="0" width="3" height="45"></rect><rect x="30" y="0" width="1" height="45"></rect><rect x="33" y="0" width="1" height="45"></rect><rect x="36" y="0" width="2" height="45"></rect><rect x="40" y="0" width="1" height="45"></rect><rect x="44" y="0" width="2" height="45"></rect><rect x="48" y="0" width="2" height="45"></rect><rect x="51" y="0" width="2" height="45"></rect><rect x="55" y="0" width="2" height="45"></rect><rect x="59" y="0" width="1" height="45"></rect><rect x="63" y="0" width="1" height="45"></rect><rect x="66" y="0" width="2" height="45"></rect><rect x="69" y="0" width="3" height="45"></rect><rect x="73" y="0" width="3" height="45"></rect><rect x="77" y="0" width="2" height="45"></rect><rect x="80" y="0" width="2" height="45"></rect><rect x="85" y="0" width="2" height="45"></rect><rect x="88" y="0" width="2" height="45"></rect><rect x="91" y="0" width="3" height="45"></rect><rect x="97" y="0" width="1" height="45"></rect><rect x="99" y="0" width="3" height="45"></rect><rect x="103" y="0" width="1" height="45"></rect><rect x="105" y="0" width="4" height="45"></rect><rect x="110" y="0" width="2" height="45"></rect><rect x="114" y="0" width="1" height="45"></rect><rect x="116" y="0" width="3" height="45"></rect><rect x="121" y="0" width="3" height="45"></rect><rect x="125" y="0" width="2" height="45"></rect><rect x="128" y="0" width="3" height="45"></rect><rect x="132" y="0" width="2" height="45"></rect><rect x="137" y="0" width="3" height="45"></rect><rect x="141" y="0" width="1" height="45"></rect><rect x="143" y="0" width="2" height="45"></rect></g></svg></td></tr></tbody></table></div><div id="div2"><table id="mainTable1"><tbody><tr class="color"><th class="tr">S no</th><th class="tr">Service</th><th class="tr">Color</th><th class="tr">Qty</th><th class="tr">Weight</th><th class="tr">Seal</th><th class="tr">Mine</th><th class="tr">Amount</th></tr></tbody>
		//         <tbody><tr>
		//         <td id="td">1</td>
		//         <td id="td1">Gemstone Jewellery Card<br>&nbsp;</td>
		//         <td id="td">White</td>
		//         <td id="td">1</td>
		//         <td id="td">1g</td>
		//         <td id="td">0</td>
		//         <td id="td">0</td>
		//         <td id="td2" class="bold">0/-</td>
		//         </tr>
		// </tbody>
		//         <tbody><tr>
		//         <td id="td">1/a</td>
		//         <td id="td1">Gemstone Jewellery Card<br>&nbsp;</td>
		//         <td id="td">red</td>
		//         <td id="td">2</td>
		//         <td id="td">1</td>
		//         <td id="td">0</td>
		//         <td id="td">0</td>
		//         <td id="td2" class="bold">1000/-</td>
		//         </tr>
		//         </tbody></table></div><div id="div3"><div id="divP"><p>I agree to the terms and conditions written on the back of the receipt.</p><p>میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.</p></div><div id="tableDiv"><table id="bottomTable" class="bold"><tbody><tr><th>Total Amount: </th><td class="color textI">1000</td></tr><tr><th>Advance: </th><td class=" textI">0</td></tr><tr id="border"><th class="padding">Balance: </th><td class="color  textI padding">1000</td></tr></tbody></table></div></div><div id="sign" class="h3"><h3>Customer Sign</h3></div></div></div>`);
		win.document.write("</div>");
		win.document.write(`</body><script>JsBarcode("#code128", ${printObj.entryNo});

        JsBarcode("#code128", ${printObj.entryNo}, {
            format: "CODE128",
            lineColor: "#0aa",
            width:1,
            height:45,
            displayValue: false
        });</script></html>`);
		win.document.write(`</body></html>`);

		win.document.close();
		setTimeout(() => {
			win.print();
		}, 700);
	}
	const abcArray = [
		"a",
		"b",
		"c",
		"d",
		"e",
		"f",
		"g",
		"h",
		"i",
		"j",
		"k",
		"l",
		"m",
		"n",
		"o",
		"p",
		"q",
		"r",
		"s",
		"t",
		"u",
		"v",
		"w",
		"x",
		"y",
		"z"
	];
	useEffect(() => {
		setPrintObj({})
		props.getSingleDataEntrySuccess(false)
	}, [])
	useEffect(() => {
		setPrintObj(props.singleEntry ? props.singleEntry : {});
	}, [props.singleEntry])
	useEffect(() => {
		if (props.history) {
			setEntryNumber(props.history.location.pathname.split("/")[2]);
		}
		// setPrintObj(props.singleEntry ? props.singleEntry : {});
		// console.log(props.singleEntry ? props.singleEntry : {})
	}, [props]);
	useEffect(() => {
		if (entryNumber) {
			props.getSingleDataEntry(entryNumber);
		}
	}, [entryNumber]);

	const dateTakeOut = (deliveryDate) => {
		let month = new Date(deliveryDate).getMonth() + 1;
		let day = new Date(deliveryDate).getDate();
		let year = new Date(deliveryDate).getFullYear();

		return `${day}-${month}-${year}`;
	};

	useEffect(() => {
		console.log(printObj.deliveryObj, "printObj.deliveryObj");
		console.log(printObj.deliveryObj && printObj.deliveryObj[0].totalAmount, "printObj.deliveryObj[0].totalAmount j");
		console.log(printObj.totalAmount, "printObj.totalAmount");
		console.log(printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved, "printObj.deliveryObj[0].paymentRecieved");
		console.log(printObj.advance, "printObj.advance");
		console.log(printObj.discountAmount, "printObj.discountAmount");
		const elsePrintObj = 0 - Number(printObj.advance) - Number(printObj.discountAmount)
		console.log(elsePrintObj, "printObj");
		if (printObj.discountAmount > 0) {

			const bal = Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
				Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
				Number(printObj.advance) -
				Number(printObj.discountAmount);
			console.log("first conditionn working", bal);
		} else {
			const bal = (printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
				printObj.advance -(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : 0)-printObj.discountAmount
			console.log("Im working now else conditoin", bal);
		}
		// console.log("print obj check",
		// 	printObj
		// 		? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
		// 		Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
		// 		Number(printObj.advance) -
		// 		Number(printObj.discountAmount)
		// 		: 0 - Number(printObj.advance) - Number(printObj.discountAmount)
		// );


	}, [printObj]);

	const expenseCalculate = (arr) => {
		let Amount = 0;

		// < th > { printObj.expenses.reduce((previousValue, currentValue) => Number(previousValue.expenseAmount) + Number(currentValue.expenseAmount)) }</th>

		if (arr.length) {
			arr.map((a, i) => {
				Amount += Number(a.expenseAmount);
			});
		}
		return Amount;
	};

	// return(
	//     <>
	//     h11
	//     <svg id="barcode">

	//     </svg>
	//     </>
	// )
	const CheckArr = (obj) => {
		return obj.consultationArray && obj.consultationArray.length
			? obj.consultationArray
			: obj.items;
	};
	return (
		<>
			{props.dataEntryLoading ? (
				<div className="loaderDiv tableLoader">
					<div>
						<img src={logo} />
					</div>
				</div>
			) : null}
			{printObj && Object.keys(printObj).length ? (
				<div id="main" className="reciptPage takeInPrint">
					<div className="innerRecieptPage">
						{/* <div className="printRecipt"> */}
						<div className="printRecipt reciptOne">
							<div>
								<div className="headReciept">Office Copy</div>
								<div className="recieptDetail">
									<table className="table1 customerDet">
										<tbody>
											<tr>
												<th
													className="bold"
												>
													Recipt No:
												</th>
												<td className="text1">{printObj.entryNo}</td>
											</tr>
											<tr>
												<th className="bold">Customer Id:</th>
												<td className="text1">{printObj.customerId}</td>
											</tr>
											<tr>
												<th className="bold" style={{ background: "#b2b2b2" }}>
													Delivered Date:{" "}
												</th>
												<td className="text1" style={{ background: "#b2b2b2" }}>
													{dateTakeOut(printObj.deliveryDate)}
												</td>
											</tr>
											<tr>
												<th className="bold">Entered By: </th>
												<td className="text1">{printObj.userName}</td>
											</tr>
											<tr>
												<th className="bold">Comment: </th>
												<td className="text1">{printObj.customerComments}</td>
											</tr>
										</tbody>
									</table>
									<table className="table2">
										<tbody>
											<tr>
												<th className="bold">Print Date:</th>
												<td className="text">{dateTakeOut(new Date(printObj.deliveryDate))}</td>
											</tr>
											<tr>
												<th className="bold">Print Time:</th>
												<td className="text">{new Date().toLocaleTimeString()}</td>
											</tr>
											<tr>
												<th className="bold" style={{ background: "#b2b2b2" }}>
													{printObj.selectBoxOrPacket
														? `${printObj.selectBoxOrPacket} No`
														: "Box No"}
													:
												</th>
												<td className="text" style={{ background: "#b2b2b2" }}>
													{printObj.boxNo}
												</td>
											</tr>
											<tr>
												<td colSpan="2">
													<svg id="barcode"></svg>
												</td>
											</tr>
										</tbody>
									</table>
									{/* </div> */}
								</div>
								<div className="itemListRecipt">
									<table>
										<thead>
											<tr>
												<th>S no</th>
												<th>Service</th>
												<th>Color</th>
												<th>Qty</th>
												<th>Weight</th>
												<th>Seal</th>
												<th>Mine</th>
												<th>Amount</th>
											</tr>
										</thead>
										<tbody>
											{CheckArr(printObj) &&
												CheckArr(printObj).map((a, i) => {
													let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
													let getServiceRate =
														Number(a.serviceRate) +
														Number(sealRate) +
														Number(mineRate) +
														Number(urgentRate) +
														Number(goldTestingRate);

													return (
														i + 1 <= 10 && (
															<>
																<tr>
																	<td>{i + 1}</td>
																	<td className="td1">
																		{`${a.service} ${a.jewelleryItems}`} <br /> &nbsp;{" "}
																	</td>
																	<td>{a.color}</td>
																	<td>{a.quantity}</td>
																	<td>
																		{a.weight}
																		{a.weightDescription}
																	</td>
																	<td>{a.sealRate}</td>
																	<td>{a.mineRate}</td>
																	<td>
																		<b>{a.stoneArr && a.stoneArr.length ? 0 : getServiceRate}</b>
																	</td>
																</tr>
																{a.stoneArr &&
																	a.stoneArr.map((b, j) => {
																		return (
																			<tr>
																				<td>
																					{i + 1}({abcArray[j]})
																				</td>
																				<td className="td1">
																					{`${a.service}`} <br /> &nbsp;{" "}
																					{`${a.jewelleryItems} (${b.selectStone})`}{" "}
																				</td>
																				<td>{b.color}</td>
																				<td>{b.Sub_quantity}</td>
																				<td>{b.sub_weight}</td>
																				<td>{a.sealRate}</td>
																				<td>{a.mineRate}</td>
																				<td>
																					<b>{`${b.sub_Rate}/-`}</b>
																				</td>
																			</tr>
																		);
																	})}
															</>
														)
													);
												})}
										</tbody>
									</table>
								</div>
							</div>
							<div className="recipetTotal">
								<div className="signCust">
									<p>
										I agree to the terms and conditions written on the back of the receipt.
										<br />
										میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
									</p>

									<div className="signBox" style={{ borderTop: "1px solid black" }}>
										Customer Signature
									</div>
								</div>
								<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
									<tbody>
										{printObj.expenses && printObj.expenses.length > 0 ? (
											<tr>
												<th>
													Expenses
													{printObj.expenses &&
														printObj.expenses.map((a) => (
															<span className="reasonTh">({a.expenseName})</span>
														))}{" "}
													:
												</th>
												<th>{expenseCalculate(printObj.expenses)}</th>
											</tr>
										) : null}
										<tr>
											<th>Total Amount:</th>
											<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
										</tr>
										{printObj.advance > 0 ?
											<tr>
												<th>Advance:</th>
												<th>{printObj.advance}</th>
											</tr>
											: null}
										{printObj.discountAmount > 0 ? (
											<tr>
												<th>
													Discount<span className="reasonTh">({printObj.discountReason})</span>:
												</th>
												<th>{printObj.discountAmount}</th>
											</tr>
										) : null}
										{printObj.discountAmount > 0 ? (
											<tr style={{ borderTop: "1px solid black" }}>
												<th>Net Amount:</th>
												<th style={{ background: "#b2b2b2" }}>
													{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
														printObj.advance -
														printObj.discountAmount}
												</th>
											</tr>
										) : ((printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : 0) -
											printObj.advance) > 0 ? (
											<tr style={{ borderTop: "1px solid black" }}>
												<th>Net Amount:</th>
												<th style={{ background: "#b2b2b2" }}>
													{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
														printObj.advance}
												</th>
											</tr>
										) : null}
										{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
											<tr>
												<th>Payment Recieved:</th>
												<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
											</tr>
											: null}
										{printObj.discountAmount > 0 ? (
											<tr style={{ borderTop: "1px solid black" }}>
												<th>Balance:</th>
												<th style={{ background: "#b2b2b2" }}>

													{printObj
														? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
														Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
														Number(printObj.advance) -
														Number(printObj.discountAmount)
														: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
												</th>
											</tr>
										) : (
											<tr style={{ borderTop: "1px solid black" }}>
												<th>Balance:</th>

												<th style={{ background: "#b2b2b2" }}>
													{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
														printObj.advance -
														(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
														printObj.discountAmount}
												</th>
											</tr>
										)}



									</tbody>
								</table>
							</div>
						</div>
						<div className="printRecipt ">
							<div>
								<div className="headReciept">Customer Copy</div>
								<div className="recieptDetail">
									<table className="table1 customerDet">
										<tbody>
											<tr>
												<th>Customer Name:</th>
												<td>{printObj.customerName}</td>
											</tr>
											<tr>
												<th>Customer Id:</th>
												<td>{printObj.customerId}</td>
											</tr>
											<tr>
												<th>Recipt No:</th>
												<td>{printObj.entryNo}</td>
											</tr>
											<tr>
												<th>Mobile No:</th>
												<td>{printObj.customerObj && printObj.customerObj.mobileNo}</td>
											</tr>
											<tr>
												<th className="bold" style={{ background: "#b2b2b2" }}>
													Delivered Date:
												</th>
												<td className="text1" style={{ background: "#b2b2b2" }}>
													{dateTakeOut(printObj.deliveryDate)}
												</td>
											</tr>
											<tr>
												<th>Entered By:</th>
												<td>{printObj.userName}</td>
											</tr>
										</tbody>
									</table>
									<table className="table2">
										<tbody>
											<tr>
												<th className="bold">Print Date:</th>
												<td className="text">{dateTakeOut(new Date())}</td>
											</tr>
											<tr>
												<th>Print Time:</th>
												<td>{new Date().toLocaleTimeString()}</td>
											</tr>
											<tr>
												<th style={{ background: "#b2b2b2" }}>
													{printObj.selectBoxOrPacket
														? `${printObj.selectBoxOrPacket} No`
														: "Box No"}
													:
												</th>
												<td style={{ background: "#b2b2b2" }}>{printObj.boxNo}</td>
											</tr>
											<tr>
												<td colSpan="2">
													<svg id="barcode"></svg>
												</td>
											</tr>
										</tbody>
									</table>
									{/* </div> */}
								</div>
								<div className="itemListRecipt">
									<table>
										<thead>
											<tr>
												<th>S no</th>
												<th>Service</th>
												<th>Color</th>
												<th>Qty</th>
												<th>Weight</th>
												<th>Seal</th>
												<th>Mine</th>
												<th>Amount</th>
											</tr>
										</thead>
										<tbody>
											{CheckArr(printObj) &&
												CheckArr(printObj).map((a, i) => {
													let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
													let getServiceRate =
														Number(a.serviceRate) +
														Number(sealRate) +
														Number(mineRate) +
														Number(urgentRate) +
														Number(goldTestingRate);
													return (
														i + 1 <= 10 && (
															<>
																<tr>
																	<td>{i + 1}</td>
																	<td className="td1">
																		{`${a.service}  ${a.jewelleryItems}`} <br /> &nbsp;{" "}
																	</td>
																	<td>{a.color}</td>
																	<td>{a.quantity}</td>
																	<td>
																		{a.weight}
																		{a.weightDescription}
																	</td>
																	<td>{a.sealRate}</td>
																	<td>{a.mineRate}</td>
																	<td>
																		<b>{a.stoneArr && a.stoneArr.length ? 0 : getServiceRate}</b>
																	</td>
																</tr>
																{a.stoneArr &&
																	a.stoneArr.map((b, j) => {
																		return (
																			<tr>
																				<td>
																					{i + 1}({abcArray[j]})
																				</td>
																				<td className="td1">
																					{`${a.service}`} <br /> &nbsp;{" "}
																					{`${a.jewelleryItems} (${b.selectStone})`}{" "}
																				</td>
																				<td>{b.color}</td>
																				<td>{b.Sub_quantity}</td>
																				<td>{b.sub_weight}</td>
																				<td>{a.sealRate}</td>
																				<td>{a.mineRate}</td>
																				<td>
																					<b>{`${b.sub_Rate}/-`}</b>
																				</td>
																			</tr>
																		);
																	})}
															</>
														)
													);
												})}
										</tbody>
									</table>
								</div>
							</div>
							<div className="recipetTotal">
								<div className="signCust">
									<p>
										I agree to the terms and conditions written on the back of the receipt.
										<br />
										میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
									</p>

									<div className="signBox" style={{ borderTop: "1px solid black" }}>
										Customer Signature
									</div>
								</div>
								<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
									<tbody>
										{printObj.expenses && printObj.expenses.length > 0 ? (
											<tr>
												<th>
													Expenses
													{printObj.expenses &&
														printObj.expenses.map((a) => (
															<span className="reasonTh">({a.expenseName})</span>
														))}{" "}
													:
												</th>
												<th>{expenseCalculate(printObj.expenses)}</th>
											</tr>
										) : null}
										<tr>
											<th>Total Amount:</th>
											<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
										</tr>
										{printObj.advance > 0 ?
											<tr>
												<th>Advance:</th>
												<th>{printObj.advance}</th>
											</tr>
											: null}
										{printObj.discountAmount > 0 ? (
											<tr>
												<th>
													Discount<span className="reasonTh">({printObj.discountReason})</span>:
												</th>
												<th>{printObj.discountAmount}</th>
											</tr>
										) : null}
										{printObj.discountAmount > 0 ? (
											<tr style={{ borderTop: "1px solid black" }}>
												<th>Net Amount:</th>
												<th style={{ background: "#b2b2b2" }}>
													{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
														printObj.advance -
														printObj.discountAmount}
												</th>
											</tr>
										) : ((printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : 0) -
											printObj.advance) > 0 ? (
											<tr style={{ borderTop: "1px solid black" }}>
												<th>Net Amount:</th>
												<th style={{ background: "#b2b2b2" }}>
													{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
														printObj.advance}
												</th>
											</tr>
										) : null}
										{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
											<tr>
												<th>Payment Recieved:</th>
												<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
											</tr>
											: null}
										{printObj.discountAmount > 0 ? (
											<tr style={{ borderTop: "1px solid black" }}>
												<th>Balance:</th>
												<th style={{ background: "#b2b2b2" }}>
													{printObj
														? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
														Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
														Number(printObj.advance) -
														Number(printObj.discountAmount)
														: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
												</th>
											</tr>
										) : (
											<tr style={{ borderTop: "1px solid black" }}>
												<th>Balance:</th>
												<th style={{ background: "#b2b2b2" }}>
													{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
														printObj.advance -
														(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : 0) -
														printObj.discountAmount}
												</th>
											</tr>
										)}


									</tbody>
								</table>
							</div>
						</div>
					</div>

					{printObj.items && printObj.items.length > 10 && (
						<div className="innerRecieptPage">
							{/* <div className="printRecipt"> */}
							<div className="printRecipt reciptOne">
								<div>
									<div className="headReciept">Office Copy</div>
									<div className="recieptDetail">
										<table className="table1 customerDet">
											<tbody>
												<tr>
													<th className="bold">Recipt No:</th>
													<td className="text1">{printObj.entryNo}</td>
												</tr>
												<tr>
													<th className="bold">Customer Id:</th>
													<td className="text1">{printObj.customerId}</td>
												</tr>
												{printObj.deliveryObj ? (
													<tr>
														<th className="bold" style={{ background: "#b2b2b2" }}>
															Delivered Date:
														</th>
														<td className="text1" style={{ background: "#b2b2b2" }}>
															{dateTakeOut(printObj.deliveryDate)}
														</td>
													</tr>
												) : null}
												<tr>
													<th className="bold">Entered By:</th>
													<td className="text1">{printObj.userName}</td>
												</tr>
												<tr>
													<th className="bold">Comment:</th>
													<td className="text1">{printObj.customerComments}</td>
												</tr>
											</tbody>
										</table>
										<table className="table2">
											<tbody>
												<tr>
													<th className="bold">Print Date:</th>
													<td className="text">{dateTakeOut(new Date())}</td>
												</tr>
												<tr>
													<th className="bold">Print Time:</th>
													<td className="text">{new Date().toLocaleTimeString()}</td>
												</tr>
												<tr>
													<th className="bold" style={{ background: "#b2b2b2" }}>
														{printObj.selectBoxOrPacket
															? `${printObj.selectBoxOrPacket} No`
															: "Box No"}
														:
													</th>
													<td className="text" style={{ background: "#b2b2b2" }}>
														{printObj.boxNo}
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<svg id="barcode"></svg>
													</td>
												</tr>
											</tbody>
										</table>
										{/* </div> */}
									</div>
									<div className="itemListRecipt">
										<table>
											<thead>
												<tr>
													<th>S no</th>
													<th>Service</th>
													<th>Color</th>
													<th>Qty</th>
													<th>Weight</th>
													<th>Seal</th>
													<th>Mine</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{CheckArr(printObj) &&
													CheckArr(printObj).map((a, i) => {
														let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
														let getServiceRate =
															Number(a.serviceRate) +
															Number(sealRate) +
															Number(mineRate) +
															Number(urgentRate) +
															Number(goldTestingRate);

														return (
															i + 1 > 10 &&
															i + 1 <= 20 && (
																<>
																	<tr>
																		<td>{i + 1}</td>
																		<td className="td1">{`${a.service} ${a.jewelleryItems}`} </td>
																		<td>{a.color}</td>
																		<td>{a.quantity}</td>
																		<td>
																			{a.weight}
																			{a.weightDescription}
																		</td>
																		<td>{a.sealRate}</td>
																		<td>{a.mineRate}</td>
																		<td>
																			<b>{a.stoneArr && a.stoneArr.length ? 0 : getServiceRate}</b>
																		</td>
																	</tr>
																	{a.stoneArr &&
																		a.stoneArr.map((b, j) => {
																			return (
																				<tr>
																					<td>
																						{i + 1}({abcArray[j]})
																					</td>
																					<td className="td1">
																						{`${a.service} ${a.jewelleryItems} (${b.selectStone})`}{" "}
																					</td>
																					<td>{b.color}</td>
																					<td>{b.Sub_quantity}</td>
																					<td>{b.sub_weight}</td>
																					<td>{a.sealRate}</td>
																					<td>{a.mineRate}</td>
																					<td>
																						<b>{`${b.sub_Rate}/-`}</b>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)
														);
													})}
											</tbody>
										</table>
									</div>
								</div>
								<div className="recipetTotal">
									<div className="signCust">
										<p>
											I agree to the terms and conditions written on the back of the receipt.
											<br />
											میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
										</p>

										<div className="signBox" style={{ borderTop: "1px solid black" }}>
											Customer Signature
										</div>
									</div>
									<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
										<tbody>
											{printObj.expenses && printObj.expenses.length > 0 ? (
												<tr>
													<th>
														Expenses
														{printObj.expenses &&
															printObj.expenses.map((a) => (
																<span className="reasonTh">({a.expenseName})</span>
															))}{" "}
														:
													</th>
													<th>{expenseCalculate(printObj.expenses)}</th>
												</tr>
											) : null}
											<tr>
												<th>Total Amount:</th>
												<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
											</tr>
											{printObj.advance > 0 ?
												<tr>
													<th>Advance:</th>
													<th>{printObj.advance}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr>
													<th>
														Discount<span className="reasonTh">({printObj.discountReason})</span>:
													</th>
													<th>{printObj.discountAmount}</th>
												</tr>
											) : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															printObj.discountAmount}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance}
													</th>
												</tr>
											)}
											{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
												<tr>
													<th>Payment Recieved:</th>
													<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
												</tr> : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{printObj
															? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															Number(printObj.advance) -
															Number(printObj.discountAmount)
															: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															printObj.discountAmount}
													</th>
												</tr>
											)}


										</tbody>
									</table>
								</div>
							</div>
							<div className="printRecipt ">
								<div>
									<div className="headReciept">Customer Copy</div>
									<div className="recieptDetail">
										<table className="table1 customerDet">
											<tbody>
												<tr>
													<th>Customer Name:</th>
													<td>{printObj.customerName}</td>
												</tr>
												<tr>
													<th>Customer Id:</th>
													<td>{printObj.customerId}</td>
												</tr>
												<tr>
													<th>Recipt No:</th>
													<td>{printObj.entryNo}</td>
												</tr>
												<tr>
													<th>Mobile No:</th>
													<td>{printObj.customerObj && printObj.customerObj.mobileNo}</td>
												</tr>
												{printObj.deliveryObj ? (
													<tr>
														<th className="bold" style={{ background: "#b2b2b2" }}>
															Delivered Date:
														</th>
														<td className="text1" style={{ background: "#b2b2b2" }}>
															{dateTakeOut(printObj.deliveryDate)}
														</td>
													</tr>
												) : null}
												<tr>
													<th>Entered By:</th>
													<td>{printObj.userName}</td>
												</tr>
												<tr>
													<th>Comment:</th>
													<td>{printObj.customerComments}</td>
												</tr>
											</tbody>
										</table>
										<table className="table2">
											<tbody>
												<tr>
													<th className="bold">Print Date:</th>
													<td className="text">{dateTakeOut(new Date())}</td>
												</tr>
												<tr>
													<th>Print Time:</th>
													<td>{new Date().toLocaleTimeString()}</td>
												</tr>
												<tr>
													<th style={{ background: "#b2b2b2" }}>
														{printObj.selectBoxOrPacket
															? `${printObj.selectBoxOrPacket} No`
															: "Box No"}
														:
													</th>
													<td style={{ background: "#b2b2b2" }}>{printObj.boxNo}</td>
												</tr>
												<tr>
													<td colSpan="2">
														<svg id="barcode"></svg>
													</td>
												</tr>
											</tbody>
										</table>
										{/* </div> */}
									</div>
									<div className="itemListRecipt">
										<table>
											<thead>
												<tr>
													<th>S no</th>
													<th>Service</th>
													<th>Color</th>
													<th>Qty</th>
													<th>Weight</th>
													<th>Seal</th>
													<th>Mine</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{CheckArr(printObj) &&
													CheckArr(printObj).map((a, i) => {
														let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
														let getServiceRate =
															Number(a.serviceRate) +
															Number(sealRate) +
															Number(mineRate) +
															Number(urgentRate) +
															Number(goldTestingRate);

														return (
															i + 1 > 10 &&
															i + 1 <= 20 && (
																<>
																	<tr>
																		<td>{i + 1}</td>
																		<td className="td1">{`${a.service} ${a.jewelleryItems}`} </td>
																		<td>{a.color}</td>
																		<td>{a.quantity}</td>
																		<td>
																			{a.weight}
																			{a.weightDescription}
																		</td>
																		<td>{a.sealRate}</td>
																		<td>{a.mineRate}</td>
																		<td>
																			<b>{a.stoneArr && a.stoneArr.length ? 0 : getServiceRate}</b>
																		</td>
																	</tr>
																	{a.stoneArr &&
																		a.stoneArr.map((b, j) => {
																			return (
																				<tr>
																					<td>
																						{i + 1}({abcArray[j]})
																					</td>
																					<td className="td1">
																						{`${a.service} ${a.jewelleryItems} (${b.selectStone})`}{" "}
																					</td>
																					<td>{b.color}</td>
																					<td>{b.Sub_quantity}</td>
																					<td>{b.sub_weight}</td>
																					<td>{a.sealRate}</td>
																					<td>{a.mineRate}</td>
																					<td>
																						<b>{`${b.sub_Rate}/-`}</b>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)
														);
													})}
											</tbody>
										</table>
									</div>
								</div>
								<div className="recipetTotal">
									<div className="signCust">
										<p>
											I agree to the terms and conditions written on the back of the receipt.
											<br />
											میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
										</p>

										<div className="signBox" style={{ borderTop: "1px solid black" }}>
											Customer Signature
										</div>
									</div>
									<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
										<tbody>
											{printObj.expenses && printObj.expenses.length > 0 ? (
												<tr>
													<th>
														Expenses
														{printObj.expenses &&
															printObj.expenses.map((a) => (
																<span className="reasonTh">({a.expenseName})</span>
															))}{" "}
														:
													</th>
													<th>{expenseCalculate(printObj.expenses)}</th>
												</tr>
											) : null}
											<tr>
												<th>Total Amount:</th>
												<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
											</tr>
											{printObj.advance > 0 ?
												<tr>
													<th>Advance:</th>
													<th>{printObj.advance}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr>
													<th>
														Discount<span className="reasonTh">({printObj.discountReason})</span>:
													</th>
													<th>{printObj.discountAmount}</th>
												</tr>
											) : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															printObj.discountAmount}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance}
													</th>
												</tr>
											)}
											{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
												<tr>
													<th>Payment Recieved:</th>
													<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
												</tr> : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{printObj
															? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															Number(printObj.advance) -
															Number(printObj.discountAmount)
															: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															printObj.discountAmount}
													</th>
												</tr>
											)}


										</tbody>
									</table>
								</div>
							</div>
						</div>
					)}

					{printObj.items && printObj.items.length > 20 && (
						<div className="innerRecieptPage">
							{/* <div className="printRecipt"> */}
							<div className="printRecipt reciptOne">
								<div>
									<div className="headReciept">Office Copy</div>
									<div className="recieptDetail">
										<table className="table1 customerDet">
											<tbody>
												<tr>
													<th className="bold">Recipt No:</th>
													<td className="text1">{printObj.entryNo}</td>
												</tr>
												<tr>
													<th className="bold">Customer Id:</th>
													<td className="text1">{printObj.customerId}</td>
												</tr>
												{printObj.deliveryObj ? (
													<tr>
														<th className="bold" style={{ background: "#b2b2b2" }}>
															Delivered Date:
														</th>
														<td className="text1" style={{ background: "#b2b2b2" }}>
															{dateTakeOut(printObj.deliveryDate)}
														</td>
													</tr>
												) : null}
												<tr>
													<th className="bold">Entered By:</th>
													<td className="text1">{printObj.userName}</td>
												</tr>
												<tr>
													<th className="bold">Comment:</th>
													<td className="text1">{printObj.customerComments}</td>
												</tr>
											</tbody>
										</table>
										<table className="table2">
											<tbody>
												<tr>
													<th className="bold">Print Date:</th>
													<td className="text">{dateTakeOut(new Date())}</td>
												</tr>
												<tr>
													<th className="bold">Print Time:</th>
													<td className="text">{new Date().toLocaleTimeString()}</td>
												</tr>
												<tr>
													<th className="bold" style={{ background: "#b2b2b2" }}>
														{printObj.selectBoxOrPacket
															? `${printObj.selectBoxOrPacket} No`
															: "Box No"}
														:
													</th>
													<td className="text" style={{ background: "#b2b2b2" }}>
														{printObj.boxNo}
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<svg id="barcode"></svg>
													</td>
												</tr>
											</tbody>
										</table>
										{/* </div> */}
									</div>
									<div className="itemListRecipt">
										<table>
											<thead>
												<tr>
													<th>S no</th>
													<th>Service</th>
													<th>Color</th>
													<th>Qty</th>
													<th>Weight</th>
													<th>Seal</th>
													<th>Mine</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{CheckArr(printObj) &&
													CheckArr(printObj).map((a, i) => {
														let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
														let getServiceRate =
															Number(a.serviceRate) +
															Number(sealRate) +
															Number(mineRate) +
															Number(urgentRate) +
															Number(goldTestingRate);

														return (
															i + 1 > 20 &&
															i + 1 <= 30 && (
																<>
																	<tr>
																		<td>{i + 1}</td>
																		<td className="td1">{`${a.service} ${a.jewelleryItems}`} </td>
																		<td>{a.color}</td>
																		<td>{a.quantity}</td>
																		<td>
																			{a.weight}
																			{a.weightDescription}
																		</td>
																		<td>{a.sealRate}</td>
																		<td>{a.mineRate}</td>
																		<td>
																			<b>{a.stoneArr ? 0 : getServiceRate}</b>
																		</td>
																	</tr>
																	{a.stoneArr &&
																		a.stoneArr.map((b, j) => {
																			return (
																				<tr>
																					<td>
																						{i + 1}({abcArray[j]})
																					</td>
																					<td className="td1">
																						{`${a.service} ${a.jewelleryItems} (${b.selectStone})`}{" "}
																					</td>
																					<td>{b.color}</td>
																					<td>{b.Sub_quantity}</td>
																					<td>{b.sub_weight}</td>
																					<td>{a.sealRate}</td>
																					<td>{a.mineRate}</td>
																					<td>
																						<b>{`${b.sub_Rate}/-`}</b>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)
														);
													})}
											</tbody>
										</table>
									</div>
								</div>
								<div className="recipetTotal">
									<div className="signCust">
										<p>
											I agree to the terms and conditions written on the back of the receipt.
											<br />
											میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
										</p>

										<div className="signBox" style={{ borderTop: "1px solid black" }}>
											Customer Signature
										</div>
									</div>
									<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
										<tbody>
											{printObj.expenses && printObj.expenses.length > 0 ? (
												<tr>
													<th>
														Expenses
														{printObj.expenses &&
															printObj.expenses.map((a) => (
																<span className="reasonTh">({a.expenseName})</span>
															))}{" "}
														:
													</th>
													<th>{expenseCalculate(printObj.expenses)}</th>
												</tr>
											) : null}
											<tr>
												<th>Total Amount:</th>
												<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
											</tr>
											{printObj.advance > 0 ?
												<tr>
													<th>Advance:</th>
													<th>{printObj.advance}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr>
													<th>
														Discount<span className="reasonTh">({printObj.discountReason})</span>:
													</th>
													<th>{printObj.discountAmount}</th>
												</tr>
											) : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															printObj.discountAmount}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance}
													</th>
												</tr>
											)}
											{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
												<tr>
													<th>Payment Recieved:</th>
													<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
												</tr> : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{printObj
															? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															Number(printObj.advance) -
															Number(printObj.discountAmount)
															: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															printObj.discountAmount}
													</th>
												</tr>
											)}


										</tbody>
									</table>
								</div>
							</div>
							<div className="printRecipt ">
								<div>
									<div className="headReciept">Customer Copy</div>
									<div className="recieptDetail">
										<table className="table1 customerDet">
											<tbody>
												<tr>
													<th>Customer Name:</th>
													<td>{printObj.customerName}</td>
												</tr>
												<tr>
													<th>Customer Id:</th>
													<td>{printObj.customerId}</td>
												</tr>
												<tr>
													<th>Recipt No:</th>
													<td>{printObj.entryNo}</td>
												</tr>
												<tr>
													<th>Mobile No:</th>
													<td>{printObj.customerObj && printObj.customerObj.mobileNo}</td>
												</tr>
												{printObj.deliveryObj ? (
													<tr>
														<th className="bold" style={{ background: "#b2b2b2" }}>
															Delivered Date:
														</th>
														<td className="text1" style={{ background: "#b2b2b2" }}>
															{dateTakeOut(printObj.deliveryDate)}
														</td>
													</tr>
												) : null}
												<tr>
													<th>Entered By:</th>
													<td>{printObj.userName}</td>
												</tr>
												<tr>
													<th>Comment:</th>
													<td>{printObj.customerComments}</td>
												</tr>
											</tbody>
										</table>
										<table className="table2">
											<tbody>
												<tr>
													<th className="bold">Print Date:</th>
													<td className="text">{dateTakeOut(new Date())}</td>
												</tr>
												<tr>
													<th>Print Time:</th>
													<td>{new Date().toLocaleTimeString()}</td>
												</tr>
												<tr>
													<th style={{ background: "#b2b2b2" }}>
														{printObj.selectBoxOrPacket
															? `${printObj.selectBoxOrPacket} No`
															: "Box No"}
														:
													</th>
													<td style={{ background: "#b2b2b2" }}>{printObj.boxNo}</td>
												</tr>
												<tr>
													<td colSpan="2">
														<svg id="barcode"></svg>
													</td>
												</tr>
											</tbody>
										</table>
										{/* </div> */}
									</div>
									<div className="itemListRecipt">
										<table>
											<thead>
												<tr>
													<th>S no</th>
													<th>Service</th>
													<th>Color</th>
													<th>Qty</th>
													<th>Weight</th>
													<th>Seal</th>
													<th>Mine</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{CheckArr(printObj) &&
													CheckArr(printObj).map((a, i) => {
														let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
														let getServiceRate =
															Number(a.serviceRate) +
															Number(sealRate) +
															Number(mineRate) +
															Number(urgentRate) +
															Number(goldTestingRate);

														return (
															i + 1 > 20 &&
															i + 1 <= 30 && (
																<>
																	<tr>
																		<td>{i + 1}</td>
																		<td className="td1">{`${a.service} ${a.jewelleryItems}`} </td>
																		<td>{a.color}</td>
																		<td>{a.quantity}</td>
																		<td>
																			{a.weight}
																			{a.weightDescription}
																		</td>
																		<td>{a.sealRate}</td>
																		<td>{a.mineRate}</td>
																		<td>
																			<b>{a.stoneArr ? 0 : getServiceRate}</b>
																		</td>
																	</tr>
																	{a.stoneArr &&
																		a.stoneArr.map((b, j) => {
																			return (
																				<tr>
																					<td>
																						{i + 1}({abcArray[j]})
																					</td>
																					<td className="td1">
																						{`${a.service} ${a.jewelleryItems} (${b.selectStone})`}{" "}
																					</td>
																					<td>{b.color}</td>
																					<td>{b.Sub_quantity}</td>
																					<td>{b.sub_weight}</td>
																					<td>{a.sealRate}</td>
																					<td>{a.mineRate}</td>
																					<td>
																						<b>{`${b.sub_Rate}/-`}</b>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)
														);
													})}
											</tbody>
										</table>
									</div>
								</div>
								<div className="recipetTotal">
									<div className="signCust">
										<p>
											I agree to the terms and conditions written on the back of the receipt.
											<br />
											میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
										</p>

										<div className="signBox" style={{ borderTop: "1px solid black" }}>
											Customer Signature
										</div>
									</div>
									<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
										<tbody>
											{printObj.expenses && printObj.expenses.length > 0 ? (
												<tr>
													<th>
														Expenses
														{printObj.expenses &&
															printObj.expenses.map((a) => (
																<span className="reasonTh">({a.expenseName})</span>
															))}{" "}
														:
													</th>
													<th>{expenseCalculate(printObj.expenses)}</th>
												</tr>
											) : null}
											<tr>
												<th>Total Amount:</th>
												<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
											</tr>
											{printObj.advance > 0 ?
												<tr>
													<th>Advance:</th>
													<th>{printObj.advance}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr>
													<th>
														Discount<span className="reasonTh">({printObj.discountReason})</span>:
													</th>
													<th>{printObj.discountAmount}</th>
												</tr>
											) : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															printObj.discountAmount}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance}
													</th>
												</tr>
											)}
											{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
												<tr>
													<th>Payment Recieved:</th>
													<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
												</tr> : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{printObj
															? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															Number(printObj.advance) -
															Number(printObj.discountAmount)
															: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															printObj.discountAmount}
													</th>
												</tr>
											)}


										</tbody>
									</table>
								</div>
							</div>
						</div>
					)}

					{printObj.items && printObj.items.length > 30 && (
						<div className="innerRecieptPage">
							{/* <div className="printRecipt"> */}
							<div className="printRecipt reciptOne">
								<div>
									<div className="headReciept">Office Copy</div>
									<div className="recieptDetail">
										<table className="table1 customerDet">
											<tbody>
												<tr>
													<th className="bold">Recipt No:</th>
													<td className="text1">{printObj.entryNo}</td>
												</tr>
												<tr>
													<th className="bold">Customer Id:</th>
													<td className="text1">{printObj.customerId}</td>
												</tr>
												{printObj.deliveryObj ? (
													<tr>
														<th className="bold" style={{ background: "#b2b2b2" }}>
															Delivered Date:
														</th>
														<td className="text1" style={{ background: "#b2b2b2" }}>
															{dateTakeOut(printObj.deliveryDate)}
														</td>
													</tr>
												) : null}
												<tr>
													<th className="bold">Entered By:</th>
													<td className="text1">{printObj.userName}</td>
												</tr>
												<tr>
													<th className="bold">Comment:</th>
													<td className="text1">{printObj.customerComments}</td>
												</tr>
											</tbody>
										</table>
										<table className="table2">
											<tbody>
												<tr>
													<th className="bold">Print Date:</th>
													<td className="text">{dateTakeOut(new Date())}</td>
												</tr>
												<tr>
													<th className="bold">Print Time:</th>
													<td className="text">{new Date().toLocaleTimeString()}</td>
												</tr>
												<tr>
													<th className="bold" style={{ background: "#b2b2b2" }}>
														{printObj.selectBoxOrPacket
															? `${printObj.selectBoxOrPacket} No`
															: "Box No"}
														:
													</th>
													<td className="text" style={{ background: "#b2b2b2" }}>
														{printObj.boxNo}
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<svg id="barcode"></svg>
													</td>
												</tr>
											</tbody>
										</table>
										{/* </div> */}
									</div>
									<div className="itemListRecipt">
										<table>
											<thead>
												<tr>
													<th>S no</th>
													<th>Service</th>
													<th>Color</th>
													<th>Qty</th>
													<th>Weight</th>
													<th>Seal</th>
													<th>Mine</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{CheckArr(printObj) &&
													CheckArr(printObj).map((a, i) => {
														let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
														let getServiceRate =
															Number(a.serviceRate) +
															Number(sealRate) +
															Number(mineRate) +
															Number(urgentRate) +
															Number(goldTestingRate);

														return (
															i + 1 > 30 &&
															i + 1 <= 40 && (
																<>
																	<tr>
																		<td>{i + 1}</td>
																		<td className="td1">{`${a.service} ${a.jewelleryItems}`} </td>
																		<td>{a.color}</td>
																		<td>{a.quantity}</td>
																		<td>
																			{a.weight}
																			{a.weightDescription}
																		</td>
																		<td>{a.sealRate}</td>
																		<td>{a.mineRate}</td>
																		<td>
																			<b>{a.stoneArr ? 0 : getServiceRate}</b>
																		</td>
																	</tr>
																	{a.stoneArr &&
																		a.stoneArr.map((b, j) => {
																			return (
																				<tr>
																					<td>
																						{i + 1}({abcArray[j]})
																					</td>
																					<td className="td1">
																						{`${a.service} ${a.jewelleryItems} (${b.selectStone})`}{" "}
																					</td>
																					<td>{b.color}</td>
																					<td>{b.Sub_quantity}</td>
																					<td>{b.sub_weight}</td>
																					<td>{a.sealRate}</td>
																					<td>{a.mineRate}</td>
																					<td>
																						<b>{`${b.sub_Rate}/-`}</b>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)
														);
													})}
											</tbody>
										</table>
									</div>
								</div>
								<div className="recipetTotal">
									<div className="signCust">
										<p>
											I agree to the terms and conditions written on the back of the receipt.
											<br />
											میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
										</p>

										<div className="signBox" style={{ borderTop: "1px solid black" }}>
											Customer Signature
										</div>
									</div>
									<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
										<tbody>
											{printObj.expenses && printObj.expenses.length > 0 ? (
												<tr>
													<th>
														Expenses
														{printObj.expenses &&
															printObj.expenses.map((a) => (
																<span className="reasonTh">({a.expenseName})</span>
															))}{" "}
														:
													</th>
													<th>{expenseCalculate(printObj.expenses)}</th>
												</tr>
											) : null}
											<tr>
												<th>Total Amount:</th>
												<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
											</tr>
											{printObj.advance > 0 ?
												<tr>
													<th>Advance:</th>
													<th>{printObj.advance}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr>
													<th>
														Discount<span className="reasonTh">({printObj.discountReason})</span>:
													</th>
													<th>{printObj.discountAmount}</th>
												</tr>
											) : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															printObj.discountAmount}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance}
													</th>
												</tr>
											)}
											{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
												<tr>
													<th>Payment Recieved:</th>
													<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
												</tr> : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{printObj
															? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															Number(printObj.advance) -
															Number(printObj.discountAmount)
															: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															printObj.discountAmount}
													</th>
												</tr>
											)}


										</tbody>
									</table>
								</div>
							</div>
							<div className="printRecipt ">
								<div>
									<div className="headReciept">Customer Copy</div>
									<div className="recieptDetail">
										<table className="table1 customerDet">
											<tbody>
												<tr>
													<th>Customer Name:</th>
													<td>{printObj.customerName}</td>
												</tr>
												<tr>
													<th>Customer Id:</th>
													<td>{printObj.customerId}</td>
												</tr>
												<tr>
													<th>Recipt No:</th>
													<td>{printObj.entryNo}</td>
												</tr>
												<tr>
													<th>Mobile No:</th>
													<td>{printObj.customerObj && printObj.customerObj.mobileNo}</td>
												</tr>
												{printObj.deliveryObj ? (
													<tr>
														<th className="bold" style={{ background: "#b2b2b2" }}>
															Delivered Date:
														</th>
														<td className="text1" style={{ background: "#b2b2b2" }}>
															{dateTakeOut(printObj.deliveryDate)}
														</td>
													</tr>
												) : null}
												<tr>
													<th>Entered By:</th>
													<td>{printObj.userName}</td>
												</tr>
												<tr>
													<th>Comment:</th>
													<td>{printObj.customerComments}</td>
												</tr>
											</tbody>
										</table>
										<table className="table2">
											<tbody>
												<tr>
													<th className="bold">Print Date:</th>
													<td className="text">{dateTakeOut(new Date())}</td>
												</tr>
												<tr>
													<th>Print Time:</th>
													<td>{new Date().toLocaleTimeString()}</td>
												</tr>
												<tr>
													<th style={{ background: "#b2b2b2" }}>
														{printObj.selectBoxOrPacket
															? `${printObj.selectBoxOrPacket} No`
															: "Box No"}
														:
													</th>
													<td style={{ background: "#b2b2b2" }}>{printObj.boxNo}</td>
												</tr>
												<tr>
													<td colSpan="2">
														<svg id="barcode"></svg>
													</td>
												</tr>
											</tbody>
										</table>
										{/* </div> */}
									</div>
									<div className="itemListRecipt">
										<table>
											<thead>
												<tr>
													<th>S no</th>
													<th>Service</th>
													<th>Color</th>
													<th>Qty</th>
													<th>Weight</th>
													<th>Seal</th>
													<th>Mine</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{CheckArr(printObj) &&
													CheckArr(printObj).map((a, i) => {
														let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
														let getServiceRate =
															Number(a.serviceRate) +
															Number(sealRate) +
															Number(mineRate) +
															Number(urgentRate) +
															Number(goldTestingRate);

														return (
															i + 1 > 30 &&
															i + 1 <= 40 && (
																<>
																	<tr>
																		<td>{i + 1}</td>
																		<td className="td1">{`${a.service} ${a.jewelleryItems}`} </td>
																		<td>{a.color}</td>
																		<td>{a.quantity}</td>
																		<td>
																			{a.weight}
																			{a.weightDescription}
																		</td>
																		<td>{a.sealRate}</td>
																		<td>{a.mineRate}</td>
																		<td>
																			<b>{a.stoneArr ? 0 : getServiceRate}</b>
																		</td>
																	</tr>
																	{a.stoneArr &&
																		a.stoneArr.map((b, j) => {
																			return (
																				<tr>
																					<td>
																						{i + 1}({abcArray[j]})
																					</td>
																					<td className="td1">
																						{`${a.service} ${a.jewelleryItems} (${b.selectStone})`}{" "}
																					</td>
																					<td>{b.color}</td>
																					<td>{b.Sub_quantity}</td>
																					<td>{b.sub_weight}</td>
																					<td>{a.sealRate}</td>
																					<td>{a.mineRate}</td>
																					<td>
																						<b>{`${b.sub_Rate}/-`}</b>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)
														);
													})}
											</tbody>
										</table>
									</div>
								</div>
								<div className="recipetTotal">
									<div className="signCust">
										<p>
											I agree to the terms and conditions written on the back of the receipt.
											<br />
											میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
										</p>

										<div className="signBox" style={{ borderTop: "1px solid black" }}>
											Customer Signature
										</div>
									</div>
									<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
										<tbody>
											{printObj.expenses && printObj.expenses.length > 0 ? (
												<tr>
													<th>
														Expenses
														{printObj.expenses &&
															printObj.expenses.map((a) => (
																<span className="reasonTh">({a.expenseName})</span>
															))}{" "}
														:
													</th>
													<th>{expenseCalculate(printObj.expenses)}</th>
												</tr>
											) : null}
											<tr>
												<th>Total Amount:</th>
												<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
											</tr>
											{printObj.advance > 0 ?
												<tr>
													<th>Advance:</th>
													<th>{printObj.advance}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr>
													<th>
														Discount<span className="reasonTh">({printObj.discountReason})</span>:
													</th>
													<th>{printObj.discountAmount}</th>
												</tr>
											) : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															printObj.discountAmount}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance}
													</th>
												</tr>
											)}
											{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
												<tr>
													<th>Payment Recieved:</th>
													<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
												</tr> : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{printObj
															? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															Number(printObj.advance) -
															Number(printObj.discountAmount)
															: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															printObj.discountAmount}
													</th>
												</tr>
											)}


										</tbody>
									</table>
								</div>
							</div>
						</div>
					)}

					{printObj.items && printObj.items.length > 40 && (
						<div className="innerRecieptPage">
							{/* <div className="printRecipt"> */}
							<div className="printRecipt reciptOne">
								<div>
									<div className="headReciept">Office Copy</div>
									<div className="recieptDetail">
										<table className="table1 customerDet">
											<tbody>
												<tr>
													<th className="bold">Recipt No:</th>
													<td className="text1">{printObj.entryNo}</td>
												</tr>
												<tr>
													<th className="bold">Customer Id:</th>
													<td className="text1">{printObj.customerId}</td>
												</tr>
												{printObj.deliveryObj ? (
													<tr>
														<th className="bold" style={{ background: "#b2b2b2" }}>
															Delivered Date:
														</th>
														<td className="text1" style={{ background: "#b2b2b2" }}>
															{dateTakeOut(printObj.deliveryDate)}
														</td>
													</tr>
												) : null}
												<tr>
													<th className="bold">Entered By:</th>
													<td className="text1">{printObj.userName}</td>
												</tr>
												<tr>
													<th className="bold">Comment:</th>
													<td className="text1">{printObj.customerComments}</td>
												</tr>
											</tbody>
										</table>
										<table className="table2">
											<tbody>
												<tr>
													<th className="bold">Print Date:</th>
													<td className="text">{dateTakeOut(new Date())}</td>
												</tr>
												<tr>
													<th className="bold">Print Time:</th>
													<td className="text">{new Date().toLocaleTimeString()}</td>
												</tr>
												<tr>
													<th className="bold" style={{ background: "#b2b2b2" }}>
														{printObj.selectBoxOrPacket
															? `${printObj.selectBoxOrPacket} No`
															: "Box No"}
														:
													</th>
													<td className="text" style={{ background: "#b2b2b2" }}>
														{printObj.boxNo}
													</td>
												</tr>
												<tr>
													<td colSpan="2">
														<svg id="barcode"></svg>
													</td>
												</tr>
											</tbody>
										</table>
										{/* </div> */}
									</div>
									<div className="itemListRecipt">
										<table>
											<thead>
												<tr>
													<th>S no</th>
													<th>Service</th>
													<th>Color</th>
													<th>Qty</th>
													<th>Weight</th>
													<th>Seal</th>
													<th>Mine</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{CheckArr(printObj) &&
													CheckArr(printObj).map((a, i) => {
														let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
														let getServiceRate =
															Number(a.serviceRate) +
															Number(sealRate) +
															Number(mineRate) +
															Number(urgentRate) +
															Number(goldTestingRate);

														return (
															i + 1 > 40 &&
															i + 1 <= 50 && (
																<>
																	<tr>
																		<td>{i + 1}</td>
																		<td className="td1">{`${a.service} ${a.jewelleryItems}`} </td>
																		<td>{a.color}</td>
																		<td>{a.quantity}</td>
																		<td>
																			{a.weight}
																			{a.weightDescription}
																		</td>
																		<td>{a.sealRate}</td>
																		<td>{a.mineRate}</td>
																		<td>
																			<b>{a.stoneArr ? 0 : getServiceRate}</b>
																		</td>
																	</tr>
																	{a.stoneArr &&
																		a.stoneArr.map((b, j) => {
																			return (
																				<tr>
																					<td>
																						{i + 1}({abcArray[j]})
																					</td>
																					<td className="td1">
																						{`${a.service} ${a.jewelleryItems} (${b.selectStone})`}{" "}
																					</td>
																					<td>{b.color}</td>
																					<td>{b.Sub_quantity}</td>
																					<td>{b.sub_weight}</td>
																					<td>{a.sealRate}</td>
																					<td>{a.mineRate}</td>
																					<td>
																						<b>{`${b.sub_Rate}/-`}</b>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)
														);
													})}
											</tbody>
										</table>
									</div>
								</div>
								<div className="recipetTotal">
									<div className="signCust">
										<p>
											I agree to the terms and conditions written on the back of the receipt.
											<br />
											میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
										</p>

										<div className="signBox" style={{ borderTop: "1px solid black" }}>
											Customer Signature
										</div>
									</div>
									<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
										<tbody>
											{printObj.expenses && printObj.expenses.length > 0 ? (
												<tr>
													<th>
														Expenses
														{printObj.expenses &&
															printObj.expenses.map((a) => (
																<span className="reasonTh">({a.expenseName})</span>
															))}{" "}
														:
													</th>
													<th>{expenseCalculate(printObj.expenses)}</th>
												</tr>
											) : null}
											<tr>
												<th>Total Amount:</th>
												<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
											</tr>
											{printObj.advance > 0 ?
												<tr>
													<th>Advance:</th>
													<th>{printObj.advance}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr>
													<th>
														Discount<span className="reasonTh">({printObj.discountReason})</span>:
													</th>
													<th>{printObj.discountAmount}</th>
												</tr>
											) : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															printObj.discountAmount}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance}
													</th>
												</tr>
											)}
											{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
												<tr>
													<th>Payment Recieved:</th>
													<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
												</tr> : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{printObj
															? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															Number(printObj.advance) -
															Number(printObj.discountAmount)
															: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															printObj.discountAmount}
													</th>
												</tr>
											)}


										</tbody>
									</table>
								</div>
							</div>
							<div className="printRecipt ">
								<div>
									<div className="headReciept">Customer Copy</div>
									<div className="recieptDetail">
										<table className="table1 customerDet">
											<tbody>
												<tr>
													<th>Customer Name:</th>
													<td>{printObj.customerName}</td>
												</tr>
												<tr>
													<th>Customer Id:</th>
													<td>{printObj.customerId}</td>
												</tr>
												<tr>
													<th>Recipt No:</th>
													<td>{printObj.entryNo}</td>
												</tr>
												<tr>
													<th>Mobile No:</th>
													<td>{printObj.customerObj && printObj.customerObj.mobileNo}</td>
												</tr>
												{printObj.deliveryObj ? (
													<tr>
														<th className="bold" style={{ background: "#b2b2b2" }}>
															Delivered Date:
														</th>
														<td className="text1" style={{ background: "#b2b2b2" }}>
															{dateTakeOut(printObj.deliveryDate)}
														</td>
													</tr>
												) : null}
												<tr>
													<th>Entered By:</th>
													<td>{printObj.userName}</td>
												</tr>
												<tr>
													<th>Comment:</th>
													<td>{printObj.customerComments}</td>
												</tr>
											</tbody>
										</table>
										<table className="table2">
											<tbody>
												<tr>
													<th className="bold">Print Date:</th>
													<td className="text">{dateTakeOut(new Date())}</td>
												</tr>
												<tr>
													<th>Print Time:</th>
													<td>{new Date().toLocaleTimeString()}</td>
												</tr>
												<tr>
													<th style={{ background: "#b2b2b2" }}>
														{printObj.selectBoxOrPacket
															? `${printObj.selectBoxOrPacket} No`
															: "Box No"}
														:
													</th>
													<td style={{ background: "#b2b2b2" }}>{printObj.boxNo}</td>
												</tr>
												<tr>
													<td colSpan="2">
														<svg id="barcode"></svg>
													</td>
												</tr>
											</tbody>
										</table>
										{/* </div> */}
									</div>
									<div className="itemListRecipt">
										<table>
											<thead>
												<tr>
													<th>S no</th>
													<th>Service</th>
													<th>Color</th>
													<th>Qty</th>
													<th>Weight</th>
													<th>Seal</th>
													<th>Mine</th>
													<th>Amount</th>
												</tr>
											</thead>
											<tbody>
												{CheckArr(printObj) &&
													CheckArr(printObj).map((a, i) => {
														let { sealRate, mineRate, urgentRate, goldTestingRate } = a;
														let getServiceRate =
															Number(a.serviceRate) +
															Number(sealRate) +
															Number(mineRate) +
															Number(urgentRate) +
															Number(goldTestingRate);

														return (
															i + 1 > 40 &&
															i + 1 <= 50 && (
																<>
																	<tr>
																		<td>{i + 1}</td>
																		<td className="td1">{`${a.service} ${a.jewelleryItems}`} </td>
																		<td>{a.color}</td>
																		<td>{a.quantity}</td>
																		<td>
																			{a.weight}
																			{a.weightDescription}
																		</td>
																		<td>{a.sealRate}</td>
																		<td>{a.mineRate}</td>
																		<td>
																			<b>{a.stoneArr ? 0 : getServiceRate}</b>
																		</td>
																	</tr>
																	{a.stoneArr &&
																		a.stoneArr.map((b, j) => {
																			return (
																				<tr>
																					<td>
																						{i + 1}({abcArray[j]})
																					</td>
																					<td className="td1">
																						{`${a.service} ${a.jewelleryItems} (${b.selectStone})`}{" "}
																					</td>
																					<td>{b.color}</td>
																					<td>{b.Sub_quantity}</td>
																					<td>{b.sub_weight}</td>
																					<td>{a.sealRate}</td>
																					<td>{a.mineRate}</td>
																					<td>
																						<b>{`${b.sub_Rate}/-`}</b>
																					</td>
																				</tr>
																			);
																		})}
																</>
															)
														);
													})}
											</tbody>
										</table>
									</div>
								</div>
								<div className="recipetTotal">
									<div className="signCust">
										<p>
											I agree to the terms and conditions written on the back of the receipt.
											<br />
											میں رسید کے پیچھے کی جانب لکھے ہوئے شرائط و ضوابط پر اتفاق کرتا ہوں.
										</p>

										<div className="signBox" style={{ borderTop: "1px solid black" }}>
											Customer Signature
										</div>
									</div>
									<table className="recipetTotalTable" style={{ borderCollapse: "collapse" }}>
										<tbody>
											{printObj.expenses && printObj.expenses.length > 0 ? (
												<tr>
													<th>
														Expenses
														{printObj.expenses &&
															printObj.expenses.map((a) => (
																<span className="reasonTh">({a.expenseName})</span>
															))}{" "}
														:
													</th>
													<th>{expenseCalculate(printObj.expenses)}</th>
												</tr>
											) : null}
											<tr>
												<th>Total Amount:</th>
												<th style={{ background: "#b2b2b2" }}>{printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount}</th>
											</tr>
											{printObj.advance > 0 ?
												<tr>
													<th>Advance:</th>
													<th>{printObj.advance}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr>
													<th>
														Discount<span className="reasonTh">({printObj.discountReason})</span>:
													</th>
													<th>{printObj.discountAmount}</th>
												</tr>
											) : null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															printObj.discountAmount}
													</th>
												</tr>
											) : ((printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : 0) -
												printObj.advance) ? (

												<tr style={{ borderTop: "1px solid black" }}>
													<th>Net Amount:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance}
													</th>
												</tr>
											) : null}
											{printObj.deliveryObj && printObj.deliveryObj[0].paymentRecieved > 0 ?
												<tr>
													<th>Payment Recieved:</th>
													<th>{printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0}</th>
												</tr>
												: null}
											{printObj.discountAmount > 0 ? (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{printObj
															? Number(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															Number(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															Number(printObj.advance) -
															Number(printObj.discountAmount)
															: 0 - Number(printObj.advance) - Number(printObj.discountAmount)}
													</th>
												</tr>
											) : (
												<tr style={{ borderTop: "1px solid black" }}>
													<th>Balance:</th>
													<th style={{ background: "#b2b2b2" }}>
														{(printObj.deliveryObj ? printObj.deliveryObj[0].totalAmount : printObj.totalAmount) -
															printObj.advance -
															(printObj.deliveryObj ? printObj.deliveryObj[0].paymentRecieved : 0) -
															printObj.discountAmount}
													</th>
												</tr>
											)}


										</tbody>
									</table>
								</div>
							</div>
						</div>
					)}
				</div>
			) : null}
			<button className="backReciptBtn" onClick={() => props.history.goBack()}>
				Back
			</button>
			<button onClick={() => printElem()} className="printReciptBtn">
				Print
			</button>
			{/* </>
                : null} */}
		</>
	);
}

const mapStateToProps = (store) => {
	return {
		entryToPrint: store.dataEntry.entryToPrint,
		singleEntry: store.dataEntry.singleEntry,
		dataEntryLoading: store.dataEntry.dataEntryLoading
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			getSingleDataEntry,
			deleteGeneratedEntry,
			getSingleDataEntrySuccess
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(TakeInPrint);

